export default {
    entityKey: 'application-screenshots',
    titles: {
        singular: 'Application Screenshot',
        plural: 'Application Screenshots'
    }
}
